import { debounce } from "lodash";

class BrixExpandableList {
  static init(...parameters) {
    return new BrixExpandableList(...parameters);
  }

  constructor(block) {
    this.block = block;
    const content = Array.from(block.children).find(
      (child) => child.classList && child.classList.contains("content")
    );

    if (content) {
      this.listItems = [...content.children].filter(
        (child) =>
          child.classList &&
          child.classList.contains("brix-expandable-list-item")
      );
    } else {
      this.listItems = [];
    }

    this.setupListeners();
  }

  setupListeners() {
    if (this.listItems.length > 0) {
      [...this.listItems].forEach((listItem) => {
        const listItemLabel = listItem.querySelector(".list-item-label");
        const listItemContent = listItem.querySelector(".list-item-content");
        if (listItemLabel && listItemContent) {
          listItemLabel.addEventListener("click", () =>
            this.onClickExpandButton(listItem, listItemContent)
          );
        }
      });
    }

    window.addEventListener(
      "resize",
      debounce(() => {
        if (this.listItems.length > 0) {
          [...this.listItems].forEach((listItem) => {
            if (listItem.classList.contains("-expanded")) {
              this.updateExpandedHeight(listItem);
            }
          });
        }
      }, 50)
    );
  }

  onClickExpandButton(listItem, listItemContent) {
    const listItemContentStyle = listItemContent.style;

    if (listItem.classList.contains("-expanded")) {
      listItem.classList.remove("-expanded");
      listItemContentStyle.height = "0px";
    } else {
      listItem.classList.add("-expanded");
      this.setContentHeight(listItemContent);
    }

    // Recalculate ancestors when transition completes
    const handleTransitionEnd = (e) => {
      if (e.target === listItemContent && e.propertyName === "height") {
        this.recalculateAncestorHeights(listItem);
        listItemContent.removeEventListener(
          "transitionend",
          handleTransitionEnd
        );
      }
    };

    listItemContent.addEventListener("transitionend", handleTransitionEnd);
  }

  updateExpandedHeight(listItem) {
    const listItemContent = listItem.querySelector(".list-item-content");
    if (!listItemContent) {
      return;
    }

    this.setContentHeight(listItemContent);
  }

  setContentHeight(listItemContent) {
    const innerBlocksWrapper = listItemContent.querySelector(".inner-blocks");
    const contentHeight = innerBlocksWrapper
      ? innerBlocksWrapper.scrollHeight
      : listItemContent.scrollHeight;
    listItemContent.style.height = `${contentHeight}px`;
  }

  recalculateAncestorHeights(listItem) {
    let parentItem = listItem.parentElement
      ? listItem.parentElement.closest(".brix-expandable-list-item")
      : null;

    while (parentItem) {
      if (parentItem.classList.contains("-expanded")) {
        this.updateExpandedHeight(parentItem);
      }

      parentItem = parentItem.parentElement
        ? parentItem.parentElement.closest(".brix-expandable-list-item")
        : null;
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock("brix-expandable-list", BrixExpandableList.init);
}
